export const redeemButtonBg = 'background-button-primary-default';
export const redeemButtonBgReversed = 'background-button-primary-default-reversed';
export const redeemButtonTextDisabled = 'text-disabled';
export const redeemButtonBgDisabledColor = Styles.color.grey.five;
export const redeemButtonIconColor = Styles.color.loyaltyHighlight;
export const pointsTranslationKey = 'points';
